import React from "react";
import styles from "./Polaroid.module.css";
import PriceCircle from "./PriceCircle";
import { Link } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";

function Polaroid(props) {
  return (
    <div
      className={styles.polaroid}
      style={{
        backgroundColor: props.BackgroundColour,
        borderColor: props.BackgroundColour,
      }}
    >
      <Link to={`${props.Link}`}>
      {/* <FaInfoCircle className={styles.Info} /> */}
      <img
        src={props.image}
        alt="Polaroid Image"
        onError={(e) =>
          (e.target.src = "/Images/Content/mh-registered.png")}
      />
      <div className={styles.NamePrice}>
        <p>{props.Name}</p>
        {props.HidePrice ? "" : <PriceCircle Price={props.Price} />}
      </div>
    
      
      </Link>
    </div>
  );
}

export default Polaroid;
